import {
  ActionIcon,
  Badge,
  Box,
  Button,
  ComboboxItem,
  Divider,
  Flex,
  Grid,
  Group,
  Input,
  List,
  NumberFormatter,
  Select,
  SelectProps,
  Text,
  Title,
  Tooltip,
} from "@mantine/core";
import {
  IconBrandBootstrap,
  IconBuildingSkyscraper,
  IconBuildingWarehouse,
  IconCheck,
  IconCoinPound,
  IconDownload,
  IconEdit,
  IconMoneybag,
  IconPencil,
  IconSearch,
  IconTicket,
  IconTimeDuration15,
  IconUser,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  useMantineReactTable,
} from "mantine-react-table";
import * as React from "react";
import { useEffect, useState } from "react";

import { DatePickerInput } from "@mantine/dates";
import { useDebouncedCallback } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { useNavigate } from "react-router-dom";
import * as xlsx from "xlsx";
import {
  repositoryPos,
  repositoryMdm,
  styleTableMantine,
} from "../../_base/_const/_constVar";
import _breadcrumb from "../../_base/component/_layout/_breadcrumb";
import { SelectListItemBase } from "../../_base/model/_base/SelectListItemBase";
import { AvatarUtils } from "../../common/ColorByName/AvatarUtils";
import { formatDateTransfer } from "../../common/FormatDate/FormatDate";
import useWindowSize from "../../common/WindownSize/WindownSize";
import { BASE_API_POS } from "../../config";
import { _localization } from "../../config/location";
import { green, orange, purple } from "../../const/variables";
import { MessageResponse } from "../../model/MessageResponse";
import {
  SelectListItem,
  SelectListItemModel,
} from "../../model/SelectListItem";

interface DepartmentCustomerOrder {
  id: number;
  name: string;
  details: {
    fullName: string;
    phoneNumber: string;
  };
}

interface DepartmentUser {
  departmentId: number;
  name: string;
  description: string | null;
  active: boolean;
  departmentCode: string;
  creationDate: string;
  createdBy: string;
  lastUpdateDate: string | null;
  lastUpdatedBy: string | null;
  address: string;
  branchId: number;
}

interface Program {
  id: number;
  code: string;
  name: string;
  createBy: string | null;
  createDate: string;
  lastUpdateDate: string | null;
  lastUpdateBy: string | null;
}

interface Permission {
  id: number;
  code: string;
  name: string;
  createBy: string | null;
  createDate: string;
  lastUpdateDate: string | null;
  lastUpdateBy: string | null;
}

interface AddressInfo {
  active: boolean;
  address: string;
  birthOfDate: string;
  code: string;
  buyerName: string;
  commune: number;
  companyName: string | null;
  contact: string | null;
  country: string | null;
  debtLimit: number | null;
  description: string | null;
  district: number;
  email: string;
  fax: string | null;
  groupId: number;
  groupName: string;
  id: number;
  name: string;
  province: number;
  sex: number;
  taxCode: string | null;
  tblDmCustomerGroupModel: any | null;
  telephoneNumber: string;
  type: number;
}

interface Customer {
  addr: string;
  createdBy: number;
  creationDate: string;
  creditLimit: number;
  email: string;
  employeeId: number;
  enabledFlag: boolean | null;
  endDateActive: string;
  id: number;
  orgId: number;
  phone: string;
  startDateActive: string;
  vatRegistrationNum: string;
  vendorCode: string;
  vendorName: string;
  vendorTypeLookupCode: string;
}
interface Customer {
  addr: string;
  createdBy: number;
  creationDate: string;
  creditLimit: number;
  email: string;
  employeeId: number;
  enabledFlag: boolean | null;
  endDateActive: string;
  id: number;
  orgId: number;
  phone: string;
  startDateActive: string;
  vatRegistrationNum: string;
  vendorCode: string;
  vendorName: string;
  vendorTypeLookupCode: string;
}

interface VCheckTransferRequest {
  soYc: string;
  ngayTaoYc: string;
  trangThaiYc: string;
  loaiYc: string;
  ghiChu: string;
  cnDi: string;
  khoDi: string;
  cnDen: string;
  khoDen: string;
  slYc?: number;
  slPx?: number;
  slPn?: number;
  lechYcVoiXuat?: number;
  lechPnVoiPx?: number;
  soPx: string;
  ngayPx?: string; // Hoặc Date
  trangThaiPx: string;
  dienGiaiPx: string;
  soPn: string;
  ngayPn?: string; // Hoặc Date
  trangThaiPn: string;
  dienGiaiPn: string;
}
interface ReportVCheckTransferRequestQuery {
  trangThai?: string;
  loaiYc?: string;
  khoDi?: string;
  khoDen?: string;
  cnDi?: string;
  cnDen?: string;
  fromDate?: string | Date;
  toDate?: string | Date;
  keySearch?: string;
  skip?: number;
  take?: number;
}

const ReportVCheckTranferRequestQueryView = () => {
  const navigate = useNavigate();
  //#region  table
  //data and fetching state
  const [data, setData] = useState<VCheckTransferRequest[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [dataBranch, setDataBranch] = useState<SelectListItemBase[]>([]);

  //table state
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    [],
  );
  // const [typeKey, settypeKey] = useState<number | null>(null);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [height, setHeight] = useState(0);

  const [search, setSearch] = useState<ReportVCheckTransferRequestQuery>({
    keySearch: "",
    trangThai: "",
    loaiYc: "",
    khoDi: "",
    khoDen: "",
    cnDi: "",
    cnDen: "",
    fromDate: new Date(
      new Date(
        new Date(new Date().setDate(new Date().getDate() - 14)).setHours(
          0,
          0,
          0,
          0,
        ),
      ).getTime() +
        7 * 60 * 60 * 1000,
    )?.toISOString(),
    toDate: new Date(
      new Date(
        new Date(new Date().setDate(new Date().getDate() + 1)).setHours(
          0,
          0,
          0,
          0,
        ),
      ).getTime() +
        7 * 60 * 60 * 1000,
    )?.toISOString(),
  });

  const [keySearch, setKeySearch] = useState<string>("");
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const sizeGrid = { base: 6, sm: 2, md: 2, lg: 2, xl: 2 };
  const [dataInvCode, setDataInvCode] = useState<SelectListItemModel[]>([]);

  const DataInvCode = async () => {
    try {
      const response = await repositoryPos.get(
        `/api/v1/TblDmInventory/get-all?checkAuth=true`,
      );
      if (response && response.httpStatusCode === 200) {
        const transformedData = response.data
          .filter((i: any) => i.value && i.text)
          .map((item: any) => {
            return {
              value: item.att1,
              label: item.text,
            };
          });

        setDataInvCode(transformedData);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };
  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    try {
      const queryParams: ReportVCheckTransferRequestQuery = {
        skip: pagination.pageIndex * pagination.pageSize,
        take: pagination.pageSize,
      };
      if (search.keySearch) queryParams.keySearch = search.keySearch;
      if (search.trangThai) queryParams.trangThai = search.trangThai;
      if (search.loaiYc) queryParams.loaiYc = search.loaiYc;
      if (search.khoDi) queryParams.khoDi = search.khoDi;
      if (search.khoDen) queryParams.khoDen = search.khoDen;
      if (search.cnDi) queryParams.cnDi = search.cnDi;
      if (search.cnDen) queryParams.cnDen = search.cnDen;
      if (search.fromDate) queryParams.fromDate = search.fromDate;
      if (search.toDate) queryParams.toDate = search.toDate;

      let sortingQuery = "";
      if (sorting && sorting.length > 0) {
        const { id, desc } = sorting[0] || {};
        if (id) {
          sortingQuery = `&sort=${encodeURIComponent(id)}&isOrder=${desc}`;
        }
      }

      const url =
        Object.entries(queryParams)
          .reduce((acc, [key, value]) => {
            if (value !== undefined && value !== "") {
              return `${acc}&${key}=${encodeURIComponent(value)}`;
            }
            return acc;
          }, "/api/v1/Report/check-tranfer-req?")
          .replace("?&", "?") + sortingQuery;

      const response =
        await repositoryPos.get<MessageResponse<VCheckTransferRequest[]>>(url);

      if (response && response.success) {
        const dataList = response?.data;
        setData(dataList);
        setRowCount(response.totalCount);
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  // Hàm gọi API chi nhánh
  const fetchDataBranch = async () => {
    const dataApi = await repositoryPos.get<
      MessageResponse<SelectListItemBase[]>
    >("/api/v1/TblDmInventory/get-select-branch");

    if (dataApi && dataApi.success) {
      const filteredData = dataApi.data.slice(1);
      setDataBranch(filteredData);
    }
  };

  useEffect(() => {
    fetchDataBranch();
    DataInvCode();
  }, []);

  const handleChangeSearchValue = useDebouncedCallback(
    <K extends keyof ReportVCheckTransferRequestQuery>(
      value: string | number | Date,
      key: K,
    ) => {
      setSearch((prevData) => ({ ...prevData, [key]: value }));
    },
    50,
  );

  const parseAttribute5Data = (row: any) => {
    try {
      const parsedData = row.attribute5 ? JSON.parse(row.attribute5) : [];
      return Array.isArray(parsedData) ? parsedData : [];
    } catch {
      return [];
    }
  };

  const columns = React.useMemo<MRT_ColumnDef<VCheckTransferRequest>[]>(
    () => [
      {
        accessorKey: "soYc",
        enableColumnActions: false,
        header: "Số yêu cầu",
      },
      {
        accessorKey: "ngayTaoYc",
        enableColumnActions: false,
        header: "Ngày tạo yêu cầu",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "trangThaiYc",
        enableColumnActions: false,
        header: "Trạng thái yêu cầu",
      },
      {
        accessorKey: "loaiYc",
        enableColumnActions: false,
        header: "Loại yêu cầu",
      },
      {
        accessorKey: "ghiChu",
        enableColumnActions: false,
        header: "Ghi chú",
      },
      {
        accessorKey: "cnDi",
        enableColumnActions: false,
        header: "Mã chi nhánh đi",
      },
      {
        accessorKey: "khoDi",
        enableColumnActions: false,
        header: "Mã kho đi",
      },
      {
        accessorKey: "cnDen",
        enableColumnActions: false,
        header: "Mã chi nhánh đến",
      },
      {
        accessorKey: "khoDen",
        enableColumnActions: false,
        header: "Mã kho đến",
      },
      {
        accessorKey: "slYc",
        enableColumnActions: false,
        header: "Số lượng yêu cầu",
      },
      {
        accessorKey: "slPx",
        enableColumnActions: false,
        header: "Số lượng phiếu xuất",
      },
      {
        accessorKey: "slPn",
        enableColumnActions: false,
        header: "Số lượng phiếu nhập",
      },
      {
        accessorKey: "lechYcVoiXuat",
        enableColumnActions: false,
        header: "Lệch yêu cầu với xuất",
      },
      {
        accessorKey: "lechPnVoiPx",
        enableColumnActions: false,
        header: "Lệch phiếu nhập với phiếu xuất",
      },

      {
        accessorKey: "soPx",
        enableColumnActions: false,
        header: "Số phiếu xuất",
      },
      {
        accessorKey: "ngayPx",
        enableColumnActions: false,
        header: "Ngày phiếu xuất",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "trangThaiPx",
        enableColumnActions: false,
        header: "Trạng thái phiếu xuất",
      },
      {
        accessorKey: "dienGiaiPx",
        enableColumnActions: false,
        header: "Diễn giải phiếu xuất",
      },

      {
        accessorKey: "soPn",
        enableColumnActions: false,
        header: "Số phiếu nhập",
      },
      {
        accessorKey: "ngayPn",
        enableColumnActions: false,
        header: "Ngày phiếu nhập",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "trangThaiPn",
        enableColumnActions: false,
        header: "Trạng thái phiếu nhập",
      },
      {
        accessorKey: "dienGiaiPn",
        enableColumnActions: false,
        header: "Diễn giải phiếu nhập",
      },
    ],
    [],
  );

  const table = useMantineReactTable<VCheckTransferRequest>({
    columns,
    data,
    enableColumnResizing: true,
    positionToolbarAlertBanner: "bottom",
    enableStickyHeader: true,
    enableStickyFooter: true,
    //add custom action buttons to top-left of top toolbar
    renderTopToolbarCustomActions: ({ table }) => <></>,
    // mantineTableHeadCellProps: {
    //   align: "center",
    // },
    //  enableStickyHeader: true,
    mantineTopToolbarProps: {
      style: {
        // borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        // marginTop: "10px",
        display: "none",
      },
    },
    localization: _localization,
    enableRowSelection: false,
    // getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["soYc", "mrt-row-select"],
        right: ["totalAmount", "actions"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    mantineTableProps: {
      striped: false,
    },
    enableSorting: false,
    onRowSelectionChange: setRowSelection,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,

    //  onColumnFiltersChange: setColumnFilters,
    //  onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    //   onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    state: {
      //  columnFilters,
      //  globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      //  sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
  });

  const transformToComboboxItem = (item: SelectListItemBase): ComboboxItem => {
    return {
      label: item.text,
      value: item.value,
    };
  };

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (180 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);

  useEffect(() => {
    if (pagination.pageIndex === 0 && data.length < pagination.pageSize) {
      fetchData();
    } else {
      fetchData();
    }
  }, [pagination.pageIndex, pagination.pageSize, sorting]);

  // Icon color mappings based on value
  const optionColors: Record<
    "Tiền dư" | "Khác" | "Thanh lý" | "Hoàn ứng công tác" | "Hoàn ứng thu mua",
    string
  > = {
    "Tiền dư": "cyan",
    Khác: "green",
    "Thanh lý": "blue",
    "Hoàn ứng công tác": orange.medium,
    "Hoàn ứng thu mua": purple.medium,
  };

  // Render function to customize the option appearance
  const renderSelectOption: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionColors[
            option.label as
              | "Tiền dư"
              | "Khác"
              | "Thanh lý"
              | "Hoàn ứng công tác"
              | "Hoàn ứng thu mua"
          ]
        }
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && <IconCheck style={{ marginInlineStart: "auto" }} />}
    </Group>
  );

  // account fund
  const optionColorsAccount: Record<
    "VND" | "USD" | "Vàng SJC 9999" | "Vàng PNJ 9999",
    string
  > = {
    VND: "cyan",
    USD: "green",
    "Vàng SJC 9999": "blue",
    "Vàng PNJ 9999": orange.medium,
  };

  const dataAccountFund = [
    { value: "1", label: "VND" },
    { value: "2", label: "USD" },
    { value: "3", label: "Vàng SJC 9999" },
    { value: "4", label: "Vàng PNJ 9999" },
  ];
  // Render function to customize the option appearance
  const renderSelectOptionAccount: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionColorsAccount[
            option.label as "VND" | "USD" | "Vàng SJC 9999" | "Vàng PNJ 9999"
          ]
        }
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && <IconCheck style={{ marginInlineStart: "auto" }} />}
    </Group>
  );

  const TypeTicket: SelectProps["renderOption"] = ({ option, checked }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={option.value === "1" ? "red" : "yellow"}
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && <IconCheck style={{ marginInlineStart: "auto" }} />}
    </Group>
  );

  const renderSelectOptionType: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={option.value === "1" ? "blue" : "green"}
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && <IconCheck style={{ marginInlineStart: "auto" }} />}
    </Group>
  );

  const handleExport = async () => {
    try {
      const queryParams: ReportVCheckTransferRequestQuery = {
        skip: pagination.pageIndex * pagination.pageSize,
        take: pagination.pageSize,
      };
      if (search.keySearch) queryParams.keySearch = search.keySearch;
      if (search.trangThai) queryParams.trangThai = search.trangThai;
      if (search.loaiYc) queryParams.loaiYc = search.loaiYc;
      if (search.khoDi) queryParams.khoDi = search.khoDi;
      if (search.khoDen) queryParams.khoDen = search.khoDen;
      if (search.cnDi) queryParams.cnDi = search.cnDi;
      if (search.cnDen) queryParams.cnDen = search.cnDen;
      if (search.fromDate) queryParams.fromDate = search.fromDate;
      if (search.toDate) queryParams.toDate = search.toDate;

      let sortingQuery = "";
      if (sorting && sorting.length > 0) {
        const { id, desc } = sorting[0] || {};
        if (id) {
          sortingQuery = `&sort=${encodeURIComponent(id)}&isOrder=${desc}`;
        }
      }
      const url =
        Object.entries(queryParams)
          .reduce((acc, [key, value]) => {
            if (value !== undefined && value !== "") {
              return `${acc}&${key}=${encodeURIComponent(value)}`;
            }
            return acc;
          }, "/api/v1/report/export-check-tranfer-req?")
          .replace("?&", "?") + sortingQuery;
      const _url = BASE_API_POS + url;
      const fullUrl = new URL(_url);
      const token = localStorage.getItem("token");
      fetch(fullUrl.toString(), {
        method: "GET", // Use the appropriate HTTP method
        headers: {
          Authorization: `Bearer ${token?.replace(/"/g, "")}`,
          "Content-Type": "application/vnd.ms-excel",
        },
      })
        .then((response) => {
          if (response.ok) {
            return response.blob(); // Assuming the response is a file or blob
          } else {
            throw new Error("Failed to fetch the resource");
          }
        })
        .then((blob) => {
          // Open the blob in a new tab
          const url = window.URL.createObjectURL(blob);
          const _name = new Date().toISOString().slice(0, 10);
          let filename = "bao_cao_dieu_chuyen" + "-" + _name + ".xlsx"; // Tên mặc định nếu không có header
          const link = document.createElement("a");
          link.href = url;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  return (
    <>
      <div
        style={{ border: "1px solid #dee2e6", padding: "5px" }}
        ref={headerRef}
      >
        <Group mb={5} justify="space-between">
          <_breadcrumb></_breadcrumb>
          <Button
            leftSection={<IconDownload size={14} />}
            color="violet"
            variant="outline"
            onClick={handleExport}
          >
            Export Excel
          </Button>
        </Group>
        <Grid>
          <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
            <Grid>
              <Grid.Col span={sizeGrid}>
                <Input
                  placeholder="Từ khóa"
                  type="text"
                  onChange={(e) => {
                    handleChangeSearchValue(e.target.value ?? "", "keySearch");
                  }}
                  leftSection={<IconSearch color="#15aabf" />}
                  onKeyDown={async (e) => {
                    if (e.key === "Enter") {
                      await fetchData();
                    }
                  }}
                />
              </Grid.Col>

              <Grid.Col span={sizeGrid}>
                <Input
                  placeholder="Trạng thái yêu cầu"
                  type="text"
                  onChange={(e) => {
                    handleChangeSearchValue(e.target.value ?? "", "trangThai");
                  }}
                  leftSection={<IconSearch color="#15aabf" />}
                  onKeyDown={async (e) => {
                    if (e.key === "Enter") {
                      await fetchData();
                    }
                  }}
                />
              </Grid.Col>

              <Grid.Col span={sizeGrid}>
                <Input
                  placeholder="Loại yêu cầu"
                  type="text"
                  onChange={(e) => {
                    handleChangeSearchValue(e.target.value ?? "", "loaiYc");
                  }}
                  leftSection={<IconSearch color="#15aabf" />}
                  onKeyDown={async (e) => {
                    if (e.key === "Enter") {
                      await fetchData();
                    }
                  }}
                />
              </Grid.Col>

              <Grid.Col span={sizeGrid}>
                <Select
                  searchable
                  clearable
                  placeholder="Chi nhánh đi"
                  key={"branch"}
                  limit={20}
                  leftSection={<IconBrandBootstrap color="#15aabf" />}
                  defaultValue={search.cnDi}
                  value={search.cnDi}
                  data={dataBranch?.map((item) => {
                    return {
                      label: `${item.att2} - ${item.text}`,
                      value: String(item.att2),
                    };
                  })}
                  onChange={(value) => {
                    handleChangeSearchValue(value ?? "", "cnDi");
                  }}
                />
              </Grid.Col>

              <Grid.Col span={sizeGrid}>
                <Select
                  searchable
                  clearable
                  placeholder="Chi nhánh đến"
                  key={"branch"}
                  limit={20}
                  leftSection={<IconBrandBootstrap color="#15aabf" />}
                  defaultValue={search.cnDen}
                  value={search.cnDen}
                  data={dataBranch?.map((item) => {
                    return {
                      label: `${item.att2} - ${item.text}`,
                      value: String(item.att2),
                    };
                  })}
                  onChange={(value) => {
                    handleChangeSearchValue(value ?? "", "cnDen");
                  }}
                />
              </Grid.Col>

              <Grid.Col span={sizeGrid}>
                <Select
                  id="subInvCode"
                  key={"subInvCode"}
                  placeholder="Chọn kho đi"
                  data={dataInvCode}
                  limit={20}
                  leftSection={
                    <IconBuildingWarehouse size={20} color="#15aabf" />
                  }
                  clearable
                  searchable
                  defaultValue={search.khoDi}
                  value={search.khoDi}
                  onChange={(value) => {
                    handleChangeSearchValue(value ?? "", "khoDi");
                  }}
                />
              </Grid.Col>

              <Grid.Col span={sizeGrid}>
                <Select
                  id="subInvCode"
                  key={"subInvCode"}
                  placeholder="Chọn kho đến"
                  limit={20}
                  data={dataInvCode}
                  leftSection={
                    <IconBuildingWarehouse size={20} color="#15aabf" />
                  }
                  clearable
                  searchable
                  defaultValue={search.khoDen}
                  value={search.khoDen}
                  onChange={(value) => {
                    handleChangeSearchValue(value ?? "", "khoDen");
                  }}
                />
              </Grid.Col>

              <Grid.Col
                span={sizeGrid}
                // style={{ flexBasis: "100%", maxWidth: "320px", flex: "1" }}
              >
                <DatePickerInput
                  type="default"
                  leftSection={<IconTimeDuration15 color="#15aabf" />}
                  size="sm"
                  placeholder="Từ ngày"
                  locale="vi"
                  //   value={value}
                  valueFormat="DD/MM/YYYY"
                  value={search.fromDate ? new Date(search.fromDate) : null}
                  onChange={(e) => {
                    const startDateISO = e
                      ? e.toLocaleDateString("en-US", {
                          month: "2-digit",
                          day: "2-digit",
                          year: "numeric",
                        })
                      : null;
                    handleChangeSearchValue(startDateISO ?? "", "fromDate");
                  }}
                  clearable
                />
              </Grid.Col>
              <Grid.Col
                span={sizeGrid}
                // style={{ flexBasis: "100%", maxWidth: "320px", flex: "1" }}
              >
                <DatePickerInput
                  leftSection={<IconTimeDuration15 color="#15aabf" />}
                  size="sm"
                  placeholder="Đến ngày"
                  locale="vi"
                  //  value={value}
                  valueFormat="DD/MM/YYYY"
                  value={search.toDate ? new Date(search.toDate) : null}
                  onChange={(e) => {
                    const startDateISO = e
                      ? e.toLocaleDateString("en-US", {
                          month: "2-digit",
                          day: "2-digit",
                          year: "numeric",
                        })
                      : null;
                    handleChangeSearchValue(startDateISO ?? "", "toDate");
                  }}
                  clearable
                />
              </Grid.Col>

              <Grid.Col span={sizeGrid}>
                <Button
                  leftSection={<IconSearch size={14} />}
                  color="blue"
                  variant="outline"
                  onClick={async () => {
                    await fetchData();
                  }}
                >
                  Tìm kiếm
                </Button>
              </Grid.Col>
            </Grid>
          </Grid.Col>
        </Grid>
      </div>
      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </>
  );
};
export default ReportVCheckTranferRequestQueryView;
